import React, { FC, useState } from "react";
import { Grid, Button } from "@material-ui/core";
import { getDeck, shuffle } from "../shared/deck";
import { cloneDeep } from "lodash";
import Card from './card.component';

interface Props {
  resetGame: () => void
}

const Bus: FC<Props> = (props) => {

  const { resetGame } = props;


  const [state, setState] = useState(() => {

    let deck = shuffle(getDeck());
    const bus = shuffle(deck.slice(0, 9));
    const top = shuffle(deck.slice(9, 18));
    deck = shuffle(deck.slice(18));

    return {
      deck: deck,
      idx: 0,
      bus: bus,
      top: top
    }
  });

  function dealCard() {
    setState({ ...state, idx: state.idx + 1 });
  }

  function reset() {
    const copy = cloneDeep(state);
    copy.idx = 0;

    // Set top cards to be in the bus
    // shuffle the rest trough the library

    for (let i = 0; i !== state.idx; ++i) {
      copy.deck.push(copy.bus[i]);
      copy.bus[i] = copy.top[i];
      copy.top[i] = copy.deck.shift()!;
    }

    // Shuffle the deck again
    copy.deck = shuffle(copy.deck);

    setState(copy);
  }

  const canNextCard = state.idx !== 9;
  const canFinish = state.idx === 9;

  return (
    <Grid container justify="center">

      <Grid item>

        <Card
          card={state.bus[0]}
          open={true}
        />

        <Card
          card={state.top[0]}
          open={state.idx > 0}
        />

      </Grid>

      <Grid item>

        <Card
          card={state.bus[1]}
          open={true}
        />

        <Card
          card={state.top[1]}
          open={state.idx > 1}
        />

      </Grid>

      <Grid item>

        <Card
          card={state.bus[2]}
          open={true}
        />

        <Card
          card={state.top[2]}
          open={state.idx > 2}
        />

      </Grid>

      <Grid item>

        <Card
          card={state.bus[3]}
          open={true}
        />

        <Card
          card={state.top[3]}
          open={state.idx > 3}
        />

      </Grid>

      <Grid item>

        <Card
          card={state.bus[4]}
          open={true}
        />

        <Card
          card={state.top[4]}
          open={state.idx > 4}
        />

      </Grid>

      <Grid item>

        <Card
          card={state.bus[5]}
          open={true}
        />

        <Card
          card={state.top[5]}
          open={state.idx > 5}
        />

      </Grid>

      <Grid item>

        <Card
          card={state.bus[6]}
          open={true}
        />

        <Card
          card={state.top[6]}
          open={state.idx > 6}
        />

      </Grid>


      <Grid item>

        <Card
          card={state.bus[7]}
          open={true}
        />

        <Card
          card={state.top[7]}
          open={state.idx > 7}
        />

      </Grid>


      <Grid item>

        <Card
          card={state.bus[8]}
          open={true}
        />

        <Card
          card={state.top[8]}
          open={state.idx > 8}
        />

      </Grid>



      <Grid item>
        {
          canNextCard && (
            <Button
              fullWidth
              onClick={dealCard}
            >
              <span>volgende kaart</span>
            </Button>
          )
        }
        {
          canFinish && (
            <Button
              fullWidth
              onClick={resetGame}
            >
              <span>uit de bus!</span>
            </Button>
          )
        }
        <Button
          fullWidth
          onClick={reset}
        >
          <span>naar begin</span>
        </Button>


      </Grid>

    </Grid>
  )
}

export default Bus;
